import React, { useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import logo from "../img/Logo-Icontec-CotizApp.png";
import microsoft from "../img/logo.jpg";
import { urlApi } from "../Services/Rest";

function Login() {
  const [correoElectronico, setCorreoElectronico] = useState("");
  const [contrasena, setContrasena] = useState("");

  const postData = async (e) => {
    e.preventDefault();
    const cookie = new Cookies();

    try {
      const response = await axios.get(
        `${urlApi}/Autentica/${correoElectronico}/${contrasena}`,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      const data = response.data;

      if (data.length > 0) {
        const user = data[0];
        cookie.set("id", user.id, { path: "/" });
        cookie.set("Nombre", user.nombre, { path: "/" });
        cookie.set("correo", user.correo, { path: "/" });
        cookie.set("contrasena", user.contrasena, { path: "/" });
        cookie.set("tipo_Usuario", user.tipoUsuario, { path: "/" });
        cookie.set("regional", user.regional, { path: "/" });
        cookie.set("area", user.area, { path: "/" });
        cookie.set("correoGestor", user.correoGestor, { path: "/" });
        cookie.set("gestorAsignado", user.gestorAsignado, { path: "/" });

        Swal.fire({
          title: "¡Bienvenido!",
          text: user.nombre,
          icon: "success",
          confirmButtonText: "Aceptar",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = `/#/InfoSolicitudes/${user.correo}`;
            window.location.reload();
          }
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Credenciales incorrectas",
          icon: "warning",
          timer: 3000,
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error",
        text: "Error en el servidor o conexión",
        icon: "error",
        timer: 3000,
      });
    }
  };

  const postIcontec = (e) => {
    e.preventDefault();
    window.location.href =
      "https://educacionapi.azurewebsites.net/api/AuthAzure";
  };

  return (
    <div className="container" style={{ paddingTop: "0px" }}>
      <div className="row justify-content-center">
        <div className="col-xl-10 col-lg-12 col-md-9">
          <div className="card o-hidden border-0 shadow-lg mt-2 mb-5">
            <div className="card-body p-0">
              <center>
                <img src={logo} alt="Logo" width="100%" />
              </center>
              <div className="text-center">
                <h1 className="h4 text-gray-900 mb-4">Iniciar sesión</h1>
              </div>
              <center>
                {/**     <form className="user" onSubmit={postData}>
                  <div className="form-group">
                    <div className="col-sm-6 mb-3 mb-sm-0">
                      <input
                        type="email"
                        className="form-control form-control-user"
                        placeholder="Correo electrónico"
                        value={correoElectronico}
                        onChange={(e) => setCorreoElectronico(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-6 mb-3 mb-sm-0">
                      <input
                        type="password"
                        className="form-control form-control-user"
                        placeholder="Contraseña"
                        value={contrasena}
                        onChange={(e) => setContrasena(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <button className="btn btn-primary" type="submit">
                    Iniciar Sesión
                  </button>
                  <hr />
                
                </form> */}
                <button className="btn btn-light" onClick={postIcontec}>
                  Iniciar sesión con  
                  <img
                    src={microsoft}
                    alt="Microsoft"
                    height="40"
                    width="100"
                    style={{ marginLeft: "10px" }}
                  />
                </button>
              </center>
              <hr />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
